module.exports = (category, action, label) => {
    // console.log(category, action, label);
    const dataLayer = window.dataLayer || [];
    window.dataLayer = dataLayer;

    dataLayer.push({
        event: 'eventTracking',
        category: category,
        action: action,
        label: label
    });
};

/* SEND EVENT: analyticsEvent('Button', 'click', 'Play'); */
